import axios from '@/utils/api'

const state = {}

const getters = {}

const actions = {
  async getFeaturesSistema ({ commit }) {
    const data = await axios({
      method: 'GET',
      url: `features`
    })
    return data
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/features.js